import React from "react";
import styled from "styled-components";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import useCurrentTripData from "../services/useCurrentTripData";
import { calculateTimeLength, normalizeTime, truncateString } from "../utils/helpers";

const TripProgressContainer = styled.div`
  border: none;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  p {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    margin-bottom: 0;
  }
`;

//* The main component
const FooterInfoProgressComponentSmall = (): JSX.Element => {
  //* Custom Hook
  const { currentData, progressBarStops } = useCurrentTripData();
  // console.log("currentData, progressBarStops:", currentData, progressBarStops);

  return (
    <React.Fragment>
      {currentData && progressBarStops ? (
        <TripProgressContainer>
          <p>
            Elapsed/left:{" "}
            <span className="span_bold">{`${calculateTimeLength(normalizeTime(currentData.startTime)?.newTimeString, "start")}/${calculateTimeLength(normalizeTime(currentData.endTime)?.newTimeString, "end")}`}</span>
          </p>
          <p>
            To:{" "}
            <span>
              <BootstrapTooltip str={currentData.headsign} />
            </span>
          </p>
          <p>
            Next:{" "}
            <span>
              <BootstrapTooltip str={`${currentData?.nextStopName} (${currentData?.nextStopId})`} />
            </span>
          </p>
        </TripProgressContainer>
      ) : null}
    </React.Fragment>
  );
};

export default FooterInfoProgressComponentSmall;

//* Tooltip
const BootstrapTooltip = ({ str }: { str: string }): JSX.Element => {
  return (
    <React.Fragment>
      <OverlayTrigger
        placement={"auto"}
        trigger={["hover", "focus"]}
        overlay={<Tooltip id={"gray-map-tooltip"}>{str}</Tooltip>}
      >
        <span className="span_bold">{truncateString(str)}</span>
      </OverlayTrigger>
    </React.Fragment>
  );
};
